import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { Connect, PropsFromRedux } from './SearchResultsContainer';
import { SearchResultDecisions } from './decision/SearchResultDecisions';
import { SearchResultCommentaries } from './commentary/SearchResultCommentaries';
import { SearchResultLegislations } from './legislation/SearchResultLegislations';
import { SearchResultLawyerOrLawfirm } from './lawyer-lawfirm/SearchResultLawyerOrLawfirm';
import { SearchResultEnterprise } from './enterprise/SearchResultEnterprise';
import { FeedbackBox } from './feedback-box/FeedbackBox';
import { withUser } from '../../../user/UserContext';
import { UserContextType } from '../../../user/user.types';
import { LawfirmHit, LawyerHit } from '../../search.types';

type Props = PropsFromRedux & UserContextType;

export class RawSearchResults extends React.Component<Props> {
  loadData = async () => {
    const { isSearchLoading, isPaginationLoading } = this.props;
    if (!isSearchLoading && !isPaginationLoading) {
      this.props.needMoreHits();
    }
  };

  render() {
    const { hits, ended, type, loggedIn } = this.props;
    const numberOfHits = hits.length;
    // infine scroll disabled if user is not logged in
    return (
      <>
        <InfiniteScroll
          pageStart={0}
          loadMore={this.loadData}
          hasMore={loggedIn && !ended}
          initialLoad={false}
        >
          <>
            {type === 'arret' && (
              // @ts-ignore
              <SearchResultDecisions decisions={hits} />
            )}
            {type === 'commentary' && (
              // @ts-ignore
              <SearchResultCommentaries commentaries={hits} />
            )}

            {type === 'law' && (
              // @ts-ignore
              <SearchResultLegislations legislations={hits} />
            )}
            {type === 'lawyer' && (
              <SearchResultLawyerOrLawfirm
                hits={hits as (LawfirmHit | LawyerHit)[]}
              />
            )}
            {type === 'enterprise' && (
              <SearchResultEnterprise enterprises={hits} />
            )}
            {ended && numberOfHits > 1 && numberOfHits < 10 && <FeedbackBox />}
          </>
        </InfiniteScroll>
      </>
    );
  }
}

export const SearchResults = Connect(withUser(RawSearchResults));
